import { IonSkeletonText } from "@ionic/react";
import React from "react";

const Skeleton__OrderBook: React.FC = () => {
  return (
    <div style={{ margin: "10px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          width: "100%",
          marginTop: "12px",
          marginBottom: "12px",
        }}
      >
        <IonSkeletonText
          animated={true}
          style={{ flex: "0 0 46px", height: "38px", margin: 0 }}
        ></IonSkeletonText>
        <IonSkeletonText
          animated={true}
          style={{ flex: "1 1 0", height: "38px", margin: 0 }}
        ></IonSkeletonText>
        <IonSkeletonText
          animated={true}
          style={{ flex: "1 1 0", height: "38px", margin: 0 }}
        ></IonSkeletonText>
        <IonSkeletonText
          animated={true}
          style={{ flex: "1 1 0", height: "38px", margin: 0 }}
        ></IonSkeletonText>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          width: "100%",
          marginBottom: "16px",
          overflow: "hidden",
        }}
      >
        <IonSkeletonText
          animated={true}
          style={{
            flex: "0 0 50px",
            height: "28px",
            borderRadius: "16px",
            margin: 0,
          }}
        ></IonSkeletonText>
        <IonSkeletonText
          animated={true}
          style={{
            flex: "0 0 80px",
            height: "28px",
            borderRadius: "16px",
            margin: 0,
          }}
        ></IonSkeletonText>
        <IonSkeletonText
          animated={true}
          style={{
            flex: "0 0 90px",
            height: "28px",
            borderRadius: "16px",
            margin: 0,
          }}
        ></IonSkeletonText>
        <IonSkeletonText
          animated={true}
          style={{
            flex: "0 0 85px",
            height: "28px",
            borderRadius: "16px",
            margin: 0,
          }}
        ></IonSkeletonText>
        <IonSkeletonText
          animated={true}
          style={{
            flex: "0 0 60px",
            height: "28px",
            borderRadius: "16px",
            margin: 0,
          }}
        ></IonSkeletonText>
      </div>
      <IonSkeletonText
        animated={true}
        style={{ width: "100%", height: "24px", marginBottom: "8px" }}
      ></IonSkeletonText>
      {[...Array(5)].map((_, index) => (
        <IonSkeletonText
          key={index}
          animated={true}
          style={{ width: "100%", height: "70px", marginBottom: "4px" }}
        ></IonSkeletonText>
      ))}
    </div>
  );
};

export default Skeleton__OrderBook;
